import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"
Chart.register(...registerables)

export default class extends Controller {
    static targets = ["canvas"]
    static values = {
        data: Array,
        labels: Object
    }

    connect() {
        if (this.hasDataValue && this.dataValue.length > 0) {
            this.renderChart()
        }
    }

    disconnect() {
        if (this.chart) {
            this.chart.destroy()
        }
    }

    renderChart() {
        const ctx = this.canvasTarget.getContext("2d")

        const labels = this.dataValue.map(step => this.labelsValue[step.name] || step.name)
        const counts = this.dataValue.map(step => step.count)

        // Colors from primary to emerald
        const backgroundColors = [
            '#4f46e5', // business_viewed
            '#6366f1', // event_viewed
            '#818cf8', // slots_loaded
            '#a5b4fc', // booking_started
            '#10b981'  // booking_completed
        ]

        this.chart = new Chart(ctx, {
            type: "bar",
            data: {
                labels: labels,
                datasets: [{
                    data: counts,
                    backgroundColor: backgroundColors,
                    borderRadius: 12,
                    barThickness: 40,
                    borderSkipped: false
                }]
            },
            options: {
                indexAxis: 'y',
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        backgroundColor: "#1e293b",
                        padding: 12,
                        cornerRadius: 12,
                        titleFont: { size: 12, weight: 'bold' },
                        bodyFont: { size: 14 },
                        callbacks: {
                            label: (context) => {
                                const step = this.dataValue[context.dataIndex]
                                return [
                                    `Count: ${step.count}`,
                                    `Conversion: ${step.percentage}%`,
                                    `Drop-off: ${step.drop_off}%`
                                ]
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        beginAtZero: true,
                        grid: { display: false },
                        ticks: {
                            color: "#94a3b8",
                            font: { size: 10, weight: 'bold' }
                        }
                    },
                    y: {
                        grid: { display: false },
                        ticks: {
                            color: "#64748b",
                            font: { size: 11, weight: 'bold' }
                        }
                    }
                }
            }
        })
    }
}
